"use client";

import React, { useEffect } from "react";
import { useAuth } from "@/context/auth-context";
import { useRouter } from "next/navigation";
import { LoginPageContent } from "@/components/login-page";
import { AppLogo } from "@/components/icons";
import { DASHBOARD_PATH } from "@/lib/app-routes";

export default function HomePage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading || !user) return;
    router.replace(DASHBOARD_PATH);
  }, [loading, user, router]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <AppLogo iconSize="size-10" textSize="text-2xl" />
      </div>
    );
  }

  if (user) {
    return (
      <div className="flex min-h-screen items-center justify-center" aria-busy="true" aria-live="polite">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" aria-hidden />
          <span className="text-sm text-muted-foreground">Taking you to the dashboard…</span>
        </div>
      </div>
    );
  }

  return <LoginPageContent />;
}
